import { Component, Input } from "@angular/core";
import { ERROR_ALERT_SELECTOR } from "../../../../crossconcern/utilities/properties/selector.property";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: ERROR_ALERT_SELECTOR,
    templateUrl: "./error.alert.component.html"
})
export class ErrorAlertComponent {
    @Input() public title: string;
    @Input() public message: string;

    constructor(public activeModal: NgbActiveModal) {}
}
